<template>
  <div class="uk-grid uk-child-width-1-1" uk-grid>
    <div>
      <div data-uk-spinner v-if="loading"></div>
      <div class="uk-align-right">
        <a
          href="#"
          @click.prevent="$router.go(-1)"
          class="uk-button uk-button-small uk-button-secondary"
        >
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <template v-if="offers.length && !loading">
      <div class="uk-width-1-1" v-for="offer in offers" :key="offer.id">
        <div class="uk-card uk-card-small uk-card-default">
          <div class="uk-card-header">
            <h3 class="uk-card-title">{{ offer.formatedDate }} | {{ offer.name }}</h3>
          </div>
          <div class="uk-card-body">
            <div class="uk-grid uk-grid-small" uk-grid>
              <div class="uk-width-small">
                <img
                  v-if="offer.vehicle.images && offer.vehicle.images.length"
                  :src="offer.vehicle.images[0]['600_cache']"
                  :alt="offer.name"
                />
                <img class="uk-width-1-1" v-else src="/img/placeholder.png" />
              </div>

              <div class="uk-width-expand uk-text-small uk-margin-remove uk-padding-small-left  ">
                <ul class="uk-list">
                  <li class="uk-margin-remove">Fahrzeugnr: {{ offer.carId }}</li>
                  <li class="uk-margin-remove" v-if="offer.data.customer">
                    Kunde: {{ offer.data.customer.company }}
                    {{ offer.data.customer.firstname }}
                    {{ offer.data.customer.lastname }}
                  </li>
                  <li v-if="Object.keys(offer.vehicle).length">
                    <span class="uk-label uk-label-success uk-text-small">verfügbar</span>
                  </li>
                  <li v-else>
                    <span class="uk-label uk-label-danger uk-text-small">nicht mehr verfügbar</span>
                  </li>
                </ul>
              </div>

              <div class="uk-width-1-3@m uk-width-1-4@l uk-text-small uk-margin-remove">
                <div class="uk-align-right">
                  <p>
                    Angebots-Preis (Brutto)<br />
                    <span class="uk-text-bold">{{ offer.priceGross | euro }}</span>
                  </p>
                </div>
              </div>

              <div class="uk-width-1-3@m uk-width-1-4@l uk-margin-remove uk-padding-small">
                <div class="uk-align-right uk-text-right" data-uk-margin>
                  <a
                    href="#"
                    @click.prevent="downloadPdf(offer)"
                    class="uk-button uk-button-small uk-button-primary"
                    >Angebot
                    <span class="uk-margin-small-left uk-icon" uk-icon="icon: download"></span>
                  </a>
                  <add-to-cart
                    size="uk-button-small"
                    v-if="offer.vehicle"
                    :disabled="offer.vehicle.inCart"
                    :vehicle-id="offer.vehicle.id"
                    @added="onAdded"
                  ></add-to-cart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="!offers.length && !loading" class="uk-margin-remove uk-h4">
      Keine Angebote vorhanden!
    </div>
  </div>
</template>
<script>
import OfferService from '@/services/offer.service'
import axios from 'axios'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import AddToCart from '@/components/vehicles/AddToCart.vue'
import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
export default {
  data() {
    return {
      offers: [],
      loading: true
    }
  },
  components: {
    AddToCart
  },
  mounted() {
    this.getOffers()
  },
  methods: {
    async getOffers() {
      const offers = await OfferService.get()
      this.offers = offers.data
      this.loading = false
    },
    downloadPdf(offer) {
      axios({
        url: `${baseURL}/offer/print/${offer.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${offer.filename}`)
        document.body.appendChild(link)
        link.click()
      })
    },
    onAdded(data) {
      iziToast.success({
        title: 'OK!',
        message: 'Fahrzeug wurde in den Warenkorb gelegt!',
        timeout: 5000,
        position: 'topCenter'
      })
      this.$emit('addedToCart', data)
    }
  }
}
</script>
